<template>
    <v-container fluid>
        <v-layout align-start>
            <v-flex>
                <v-row no-gutters justify="center" class="pb-0 mb-0">
                    <span style="font-size: 30px; color: #616161">
                        <v-icon large class="pr-1 pb-2">domain_disabled</v-icon>
                        Departamentos</span>
                </v-row>
                <v-card outlined>
                    <v-card-text>
                        <v-data-table :headers="headers" :items="departments" :search="search" dense>
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Total: {{ departments.length }}</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                    <v-text-field outlined class="text-xs-center" v-model="search" append-icon="search"
                                        label="Buscar" single-line hide-details dense>
                                    </v-text-field>
                                    <v-spacer></v-spacer>
                                    <v-btn color="success" text dark class="mb-2" @click="clearDepartments()">
                                        <v-icon>add</v-icon> Nuevo Departamento
                                    </v-btn>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.edit`]="{ item }">
                                <v-icon large color="accent" class="mr-2" @click="editItem(item)">
                                    edit
                                </v-icon>
                            </template>
                            <template v-slot:[`item.status`]="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-show="item.status_id == '1'" large color="success" v-bind="attrs" v-on="on"
                                            @click="deactivate_department(2, item)">
                                            toggle_on
                                        </v-icon>
                                        <v-icon v-show="item.status_id == '2'" large color="error" v-bind="attrs" v-on="on"
                                            @click="deactivate_department(1, item)">
                                            toggle_off
                                        </v-icon>
                                    </template>
                                    <span>{{ item.status_id == '1' ? 'Desactivar' : 'Activar' }}</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
                <v-dialog v-model="dialog" max-width="70%">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container fluid>
                                <v-row justify="center">
                                    <v-col cols="12" md="2">
                                        <v-text-field v-model="newDepartment.code" required dense hide-details
                                            label="Codigo" type="number" outlined :readonly="isEdit"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="5">
                                        <v-autocomplete v-model="newDepartment.origen" :items="itemsDepartment"
                                            color="cyanText" outlined label="Pertenece al departamento"
                                            prepend-inner-icon="business" required dense clearable
                                            hide-details></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-card outlined class="mt-3">
                                    <v-container fluid>
                                        <v-row justify="center" align="center">

                                            <label class="Heading 5">Agregar nombre.</label>

                                            <v-divider class="mx-4" inset vertical></v-divider>
                                            <v-col cols="12" sm="3" md="3">
                                                <v-text-field v-model="newDepartment_names.department_names_description
                                                    " label="Nombre" required outlined hide-details dense></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3" md="2">
                                                <v-autocomplete v-model="newDepartment_names.language_id"
                                                    :items="itemsLenguagues" label="Lenguaje" outlined hide-details dense
                                                    required></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="3" md="2">
                                                <v-autocomplete v-model="newDepartment_names.country_id"
                                                    :items="itemsCountries" label="Pais" outlined hide-details dense
                                                    required></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="3" md="1">
                                                <v-btn class="mx-2" fab dark small color="success" @click="addLenguaje()">
                                                    <v-icon dark> add </v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                                <v-card outlined class="mt-3" v-show="newDepartment.department_names.length > 0">
                                    <v-container fluid>
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">Nombre</th>
                                                        <th class="text-left">Idioma</th>
                                                        <th class="text-left">Pais</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="item in newDepartment.department_names" v-show="item.department_names_description != null
                                                        " :key="item.language_id">
                                                        <td>
                                                            <v-text-field v-model="item.department_names_description
                                                                " required dense hide-details></v-text-field>
                                                        </td>
                                                        <td>
                                                            {{ item.languages_description_long }}
                                                        </td>
                                                        <td>
                                                            {{ item.countries_description }}
                                                        </td>
                                                        <td>
                                                            <v-icon color="error" @click="removeName(item)">cancel</v-icon>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-container>
                                </v-card>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" text @click="save">
                                Guardar
                            </v-btn>
                            <v-btn color="red darken-1" text @click="dialog = false">
                                Cancelar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="40%">
                    <v-card>
                        <v-card-title class="Heading 6" justify="center">Seguro que desea {{
                            departmentToDesactive.status === 2 ? 'des' : '' }}activar el departamento
                            {{ departmentToDesactive.description }}?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" text @click="deactivate_departmentConfirm(2)">Confirmar</v-btn>
                            <v-btn color="red darken-1" text @click="dialogDelete = false">Cancelar</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>
    </v-container>
</template>
  
  
<script>
export default {
    data: () => ({
        dialog: false,
        start: null,
        end: null,
        dialogDelete: false,
        headers: [
            {
                text: "Codigo",
                align: "start",
                value: "id",
            },
            { text: "Nombre", value: "department_name" },
            { text: "Estatus", value: "status", sortable: false },
            { text: "Editar", value: "edit", sortable: false },
        ],
        search: "",
        departments: [],
        itemsDepartment: [],
        newDepartment_names: {
            country_id: "",
            countries_description: "",
            language_id: "",
            languages_description_long: "",
            languages_description_short: "",
            department_names_description: "",
        },
        newDepartment: {
            code: 0,
            origen: null,
            department_names: [],
        },
        itemsLenguagues: [],
        itemsCountries: [],
        isEdit: false,
        departmentToDesactive: {
            id: 0,
            description: "",
            status: 0,
        },
    }),
    components: {
        // Barra
    },
    computed: {
        formTitle() {
            return this.isEdit == false
                ? "Nuevo departamento"
                : "Editar departamento";
        },
    },
    created() {
        this.initialize();
    },

    methods: {
        async initialize() {
            this.getData();
            //combo lenguajes----------------------------------------------
            const response = await this.api_Get("humanResource/laguagues");
            const dataCities = await response.json();
            dataCities.forEach((element) =>
                this.itemsLenguagues.push({
                    value: element.id,
                    text: element.description_long,
                })
            );
            //combo paises----------------------------------------------
            this.itemsCountries = await this.g_ComboGeneric(
                "humanResource/countries"
            );
            //combo Departamentos----------------------------------------------
            this.itemsDepartment = await this.g_departments();
   
        },  
        async getData() {
            const response = await this.api_Get("humanResource/departments");
            const data = await response.json();
            this.departments = data;
        },

        editItem(item) {
            this.isEdit = true;
            this.newDepartment = Object.assign({}, item);
            this.newDepartment.origen = this.newDepartment.department_names[0].origen;
            this.newDepartment.parent = this.newDepartment.department_names[0].origen;
            this.dialog = true;
        },

        deactivate_department(type, item) {
            this.departmentToDesactive.description = item.department_name;
            this.departmentToDesactive.id = item.code;
            this.departmentToDesactive.status = type;
            this.dialogDelete = true;
        },

        async deactivate_departmentConfirm() {
            if (this.departmentToDesactive.id == 0) {
                this.$toast.error('Escoja el departamento a desactivar!');
                return
            }
            const response = await this.api_Put("humanResource/changeStatusDepartment", {
                department_id: this.departmentToDesactive.id,
                status_id: this.departmentToDesactive.status
            });
            if (response.status == 200) {
                 this.$toast.success(`El departamento ${this.departmentToDesactive.description} ha sido ${this.departmentToDesactive.status === 2 ? 'des' : ''}activado correctamente!`);
                await this.getData();
                this.dialogDelete = false;
                this.departmentToDesactive.description = null;
                this.departmentToDesactive.id = 0;
                this.departmentToDesactive.status = 0;
                return
            }

            this.$toast.error('Error al desactivar el departamento!');
        },
        addLenguaje() {
            if (this.newDepartment_names.department_names_description == "") {
                this.$toast.error("Especifique el nombre!");
                return;
            }
            if (this.newDepartment_names.country_id == "") {
                this.$toast.error("Escoja un pais!");
                return;
            }
            if (this.newDepartment_names.language_id == "") {
                this.$toast.error("Escoja un lenguaje!");
                return;
            }
            for (var item of this.newDepartment.department_names) {
                if (this.newDepartment_names.country_id == item.country_id) {
                    this.$toast.error("No puede agregar 2 en el mismo pais!");
                    return;
                }
            }
            for (var item of this.newDepartment.department_names) {
                if (this.newDepartment_names.language_id == item.language_id) {
                    this.$toast.error("No puede agregar 2 del mismo idioma!");
                    return;
                }
            }

            let idioma;
            for (var key in this.itemsLenguagues) {
                if (
                    this.newDepartment_names.language_id ==
                    this.itemsLenguagues[key].value
                ) {
                    idioma = this.itemsLenguagues[key].text;
                    break;
                }
            }
            let pais;
            for (var key in this.itemsCountries) {
                if (
                    this.newDepartment_names.country_id == this.itemsCountries[key].value
                ) {
                    pais = this.itemsCountries[key].text;
                    break;
                }
            }

            this.newDepartment.department_names.push({
                department_id: this.newDepartment.id,
                country_id: this.newDepartment_names.country_id,
                countries_description: pais,
                language_id: this.newDepartment_names.language_id,
                languages_description_long: idioma,
                department_names_description:
                    this.newDepartment_names.department_names_description,
            });

            this.newDepartment_names = {
                country_id: "",
                countries_description: "",
                language_id: "",
                languages_description_long: "",
                languages_description_short: "",
                department_names_description: "",
            };
        },
        removeName(item) {
            let index = this.newDepartment.department_names.indexOf(item);
            this.newDepartment.department_names.splice(index, 1);
        },
        async save() {
            let validateCode = this.itemsDepartment.find((element) => element.value === this.newDepartment.code && this.isEdit == false);
            if (validateCode != undefined) {
                this.$toast.error('Este codigo de departamento ya se encuentra registrado!');
                return
            }
            if (this.newDepartment.code == null || this.newDepartment.code == 0) {
                this.$toast.error('Indique el codigo del departamento!');
                return
            }
            if (this.newDepartment.department_names.length == 0) {
                this.$toast.error('El departamento debe tener al menos un nombre!');
                return
            }

            let department_descriptions = [];
            for (var item of this.newDepartment.department_names) {
                department_descriptions.push({
                    department_id: this.newDepartment.id == undefined ? this.newDepartment.code : this.newDepartment.id,
                    country_id: item.country_id,
                    language_id: item.language_id,
                    department_names_description: item.department_names_description,
                });
            }
            if (this.isEdit == true) {
                //Modificar
                const result = await this.api_Put("humanResource/departments", {
                    department_descriptions: department_descriptions,
                    const_parent_id: this.newDepartment.parent,
                    origen: this.newDepartment.origen == null ? 0 : this.newDepartment.origen,
                    code: this.newDepartment.code
                });
                if (result.status == 200) {
                     this.$toast.success("Actualizado con exito!");
                } else {
                    this.$toast.error("Error al actualizar!");
                    return
                }
            } else {
                //Crear nuevo
                const result = await this.api_Post("humanResource/departments", {
                    department_descriptions: department_descriptions,
                    origen: this.newDepartment.origen == null ? 0 : this.newDepartment.origen,
                    code: this.newDepartment.code
                });
                if (result.status == 200) {
                     this.$toast.success('Se ha creado correctamente!');
                } else {
                    this.$toast.error("Error al crear el departamento!");
                    return
                }
            }
            await this.getData();
            this.dialog = false;
        },
        clearDepartments() {
            this.isEdit = false;
            this.newDepartment.code = parseInt(this.departments[0].code) + 1;
            this.newDepartment.department_names = [];
            this.newDepartment.origen = null;
            this.dialog = true;
        },
    },
};
</script>